import { useAbTestFeatureVariant } from '@sprd/sprd-abtest-next/client';

/**
 * Client-side gate for the "multi-coupon" A/B test (DEV-232239): the `variant` keeps several
 * coupons active at once and validates them with pricing-service before applying them to the
 * cart. Control (`control`, also the fallback) keeps a single active coupon, as before.
 */
export const useIsMultiCouponEnabled = () => {
  return useAbTestFeatureVariant("multi-coupon", "control") === "variant";
};